import { ECategory } from '../types/recommendation';

export function getIsDailyRent(category: ECategory | null): boolean {
  return category ? category.indexOf('daily') > -1 : false;
}
